import styled from 'styled-components'

export const PaginationContainer = styled.nav`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  flex: 1;

  padding-top: ${({ theme }) => theme.spacings[8]};
  padding-bottom: ${({ theme }) => theme.spacings[2]};

  background-color: transparent;

  ol {
    display: flex;
    flex-direction: row;
    align-items: center;

    list-style: none;

    li {
      button[data-link='true'] {
        display: flex;
        align-items: center;
        justify-content: center;

        width: ${({ theme }) => theme.fontSizes.xxlg};
        height: ${({ theme }) => theme.fontSizes.xxlg};
        border-radius: 50%;

        color: ${({ theme }) => theme.colors.warning};

        &.active,
        &:hover {
          color: ${({ theme }) => theme.colors.white};
          background-color: ${({ theme }) => theme.colors.warning};
          transition: 0.3s;
        }
      }

      span {
        margin-top: auto;
        font-size: ${({ theme }) => theme.fontSizes.xxsm};
        color: ${({ theme }) => theme.colors.warning};
      }
    }

    li:first-of-type,
    li:last-of-type {
      button {
        color: ${({ theme }) => theme.colors.white};
        width: ${({ theme }) => theme.fontSizes.xxlg};
        height: ${({ theme }) => theme.fontSizes.xxlg};

        border: ${({ theme }) => `2px solid ${theme.colors.warning}`};
        border-radius: 50%;

        background-color: ${({ theme }) => theme.colors.warning};
        transition: 0.3s;

        &:disabled {
          color: ${({ theme }) => theme.colors.white};
          border-color: ${({ theme }) => theme.colors.warning};
        }

        &:hover:not(:disabled) {
          color: ${({ theme }) => theme.colors.white};
          background-color: ${({ theme }) => theme.colors.warning};
        }
      }
    }

    li + li {
      margin-left: ${({ theme }) => theme.spacings[2.5]};
    }
  }
`
